<template>
  <div class="col-sm-12 nopads">
    <div class="col-sm-12 editor-form">
      <h3 class="editor-header">{{ allowanceUpdate.id > 0 ? $t('meal_allowance.edit') : $t('meal_allowance.add') }}</h3>
      <div class="col-sm-12 form-data nopads">
        <!-- Users -->
        <div
          v-if="allowanceUpdate.id < 1"
          class="nopads"
        >
          <span class="span-title">
            {{ $t('work_time.user') }}
          </span>
          <select
            v-model="allowanceUpdate.user.id"
            class="form-select form-select-sm mb-3"
            :disabled="!users || users.length < 1"
          >
            <option
              :value="null"
              disabled
            >
              {{ $t('work_time.select_user') }}
            </option>
            <option
              v-for="item in users"
              :key="item.id"
              :value="item.id"
            >
              {{ item.last_name }}, {{ item.first_name }}
            </option>
          </select>
        </div>
        <div v-else>
          <h3>
            {{ allowanceUpdate.user.first_name + ' ' + allowanceUpdate.user.last_name }}
          </h3>
        </div>

        <!-- Date -->
        <div class="row nopads">
          <div class="col-sm-6 nopads">
            <span class="span-title">
              {{ $t('work_time.start') }}
            </span>
            <date-time-picker
              v-model:date="allowanceUpdate.date"
              :placeholder="$t('observations_videos.search_input_format')"
            />
          </div>
          <div class="col-sm-6 nopads pl-2">
            <span class="span-title">
              {{ $t('meal_allowance.increased') }}
            </span>
              <div class="form-check">
                  <input
                      class="form-check-input pt-2"
                      type="checkbox"
                      id="checkbox-1"
                      v-model="allowanceUpdate.increased_allowance"
                  />
                  <label class="form-check-label text-light" for="onlyUserOwnedContracts">
                      {{ $t('meal_allowance.increased') }}
                  </label>
              </div>
          </div>
        </div>

        <div class="col-sm-12 d-flex justify-content-end">
          <button class="btn btn-secondary form-button" @click.stop="$emit('close')">
              {{ $t('common.close') }}
          </button>
          <button v-if="isObserver && allowanceUpdate.id>0" class="btn btn-primary form-button" :disabled="loading" @click.stop="approveAllowance">
              {{ $t('meal_allowance.approve_allowance') }}
          </button>
          <button class="btn btn-success form-button" :disabled="loading" @click.stop="submit">
              {{ $t('common.save') }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {allowanceHelper} from '../mixins/AllowanceMixin'
import DateTimePicker from "@/components/common/DateTimePicker";
import {inject} from "vue";

export default {
    name: 'MealAllowanceEditor',
    components: { DateTimePicker },
    mixins: [restApi, allowanceHelper],
    props: {
        isObserver: Boolean,
        allowance: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            users: [],
            allowanceUpdate: this.newMealAllowance(),
            PARTIAL_ALLOWANCE_HOURS: 6
        }
    },

    mounted: function () {
        if (this.allowance) {
            this.allowanceUpdate = this.allowance
        }
        this.fetchUsers()
    },

    methods: {

        fetchUsers: function () {
            this.restFetch(this.userUrl, this.handleUsers)
        },

        handleUsers: function (response) {
            this.users = response.data
            this.loading = false
        },

        submit: function () {
            if (!this.allowanceUpdate.date) {
                this.showAlert(this.$t('daily_allowance.error_start_missing'))
                return
            }
            this.loading = true
            let json = JSON.parse(JSON.stringify(this.allowanceUpdate))
            if (json.user) {
                json.user = {id: json.user.id}
            }
            if (json.id > 0) {
                this.restUpdate(this.mealAllowanceUrl, json, this.success, this.fail)
            } else {
                this.restAdd(this.mealAllowanceUrl, json, this.success, this.fail)
            }
        },

        success: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },

        fail: function (response) {
            this.loading = false
            if (response.status === 406) {
                this.showAlert(this.$t('meal_allowance.error_overlapping'))
            } else {
                if (this.allowanceUpdate.id < 0) {
                    this.showAlert(this.$t('common.alert_add_failed'))
                } else {
                    this.showAlert(this.$t('common.alert_update_failed'))
                }
            }
        },
        approveAllowance: function () {
            this.loading = true
            this.restAdd(this.mealAllowanceApproveUrl + this.allowanceUpdate.id, null, this.success, this.fail)
        }
    }
}
</script>
